import styled from 'styled-components'

export const PriceNewStyled = styled.div`
  width: 100%;
  height: calc(100% - 2px);
  background: #f2b80c1a;
  display: flex;
  align-items: center;
  padding: 0 8px 0 4px;
`
